module.exports = __webpack_public_path__ + "659ef81ce790a107a3617a756de48f5e.svg";